// // src/pages/AIIntegration.jsx
// import React from "react";
// import "./ServicePage.css";
// import {
//   FaRobot,
//   FaComments,
//   FaChartLine,
//   FaBrain,
//   FaCogs,
//   FaBolt,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";

// export default function AIIntegration() {
//   return (
//     <div className="svc-page">
//       {/* HERO */}
//       <section className="svc-hero">
//         <div className="svc-hero-inner">
//           <div className="svc-hero-left">
//             <span className="svc-hero-tag">AI Integration</span>
//             <h1 className="svc-hero-title">
//               Add <span className="svc-hero-highlight">AI superpowers</span> to
//               your products and workflows.
//             </h1>
//             <p className="svc-hero-subtitle">
//               We help you embed AI into your apps — from chatbots and automation
//               to prediction and personalization — using practical,
//               production-ready architectures.
//             </p>

//             <ul className="svc-hero-points">
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   AI chatbots that actually understand your business domain.
//                 </span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Workflow automation that reduces manual, repetitive tasks.
//                 </span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Predictive insights you can trust, with clear visibility.
//                 </span>
//               </li>
//             </ul>

//             {/* <div className="svc-hero-cta-row">
//               <button className="svc-cta-primary">Plan an AI Pilot</button>
//               <button className="svc-cta-secondary">See Example Use-Cases</button>
//             </div> */}
//           </div>

//           {/* RIGHT VISUAL */}
//           <div className="svc-hero-right">
//             <div className="svc-hero-orbit">
//               <div className="svc-hero-orbit-ring" />
//               <div className="svc-hero-orbit-center">
//                 <FaRobot />
//               </div>

//               <div className="svc-hero-pill-icon svc-hero-pill-top">
//                 <span className="svc-pill-dot" />
//                 <span>Chatbots</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-right">
//                 <span className="svc-pill-dot" />
//                 <span>Automation</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-bottom">
//                 <span className="svc-pill-dot" />
//                 <span>Analytics</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* METRICS */}
//         <div className="svc-hero-metrics">
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">60% ↓</div>
//             <div className="svc-metric-label">Support handling time</div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">3×</div>
//             <div className="svc-metric-label">More automation coverage</div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">90%</div>
//             <div className="svc-metric-label">User satisfaction on pilots</div>
//           </div>
//         </div>
//       </section>

//       {/* MAIN CONTENT */}
//       <main className="svc-inner">
//         {/* WHAT WE BUILD */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>What we build with AI</h2>
//             <p>
//               We don&apos;t chase buzzwords — we focus on AI use cases that
//               improve customer experience and internal productivity.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaComments />
//               </div>
//               <h3>AI Chatbots & Assistants</h3>
//               <p>
//                 Domain-trained bots that answer questions, collect data, and
//                 route conversations — integrated with your CRM and internal
//                 systems.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaBolt />
//               </div>
//               <h3>Process Automation</h3>
//               <p>
//                 Use AI to summarize tickets, draft replies, validate forms, and
//                 trigger workflows across your tools.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaBrain />
//               </div>
//               <h3>Prediction & Personalization</h3>
//               <p>
//                 From churn risk to next-best-offer and content recommendations,
//                 we integrate ML models where they move the needle.
//               </p>
//             </div>
//           </div>
//         </section>

//         {/* USE CASES */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>Sample AI use-cases for software teams</h2>
//             <p>
//               Start small, prove value, and then expand AI coverage across your
//               product and operations.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <h3>Support & CX</h3>
//               <ul className="svc-list">
//                 <li>24×7 support bots for website or app.</li>
//                 <li>AI-assisted agents with suggested replies.</li>
//                 <li>Automatic summaries & ticket tagging.</li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Operations & Internal Tools</h3>
//               <ul className="svc-list">
//                 <li>Natural language search across documents and logs.</li>
//                 <li>AI helpers inside dashboards and admin panels.</li>
//                 <li>Log and data analysis for faster decision-making.</li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Product Features</h3>
//               <ul className="svc-list">
//                 <li>Smart suggestions, auto-complete, and content drafting.</li>
//                 <li>Personalized feeds and recommendations.</li>
//                 <li>Adaptive onboarding and guidance.</li>
//               </ul>
//             </div>
//           </div>
//         </section>

//         {/* DELIVERY APPROACH + STACK */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>How we deliver AI projects</h2>
//             <p>
//               We focus on fast pilots, measurable KPIs, and integrations that
//               respect your security and compliance needs.
//             </p>
//           </div>

//           <div className="svc-stats-row" style={{ marginBottom: "16px" }}>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">01 · Discovery Workshop</div>
//               <div className="svc-stat-value">
//                 Identify 2–3 high-impact use cases, data sources, and success
//                 metrics.
//               </div>
//             </div>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">02 · Pilot & Integrate</div>
//               <div className="svc-stat-value">
//                 Build a small, focused pilot integrated with your app or tools.
//               </div>
//             </div>
//             <div className="svc-stat-card">
//               <div className="svc-stat-label">03 · Expand & Govern</div>
//               <div className="svc-stat-value">
//                 Scale to more teams and features with guardrails and monitoring.
//               </div>
//             </div>
//           </div>

//           <div className="svc-card">
//             <h3>Platforms & tooling</h3>
//             <p className="svc-text-soft">
//               We combine modern AI platforms with your existing stack.
//             </p>
//             <div className="svc-chip-row" style={{ marginTop: "10px" }}>
//               <span className="svc-chip">OpenAI / Azure OpenAI</span>
//               <span className="svc-chip">Vector search & embeddings</span>
//               <span className="svc-chip">Python / Node.js</span>
//               <span className="svc-chip">React & React Native</span>
//               <span className="svc-chip">LangChain / custom pipelines</span>
//               <span className="svc-chip">Your existing APIs & DBs</span>
//             </div>
//           </div>

//           <div className="svc-cta-block">
//             <h3>Ready to run an AI pilot?</h3>
//             <p>
//               Tell us where you want to save time or improve experience. We’ll
//               propose 1–2 AI experiments with timelines and estimated impact.
//             </p>
//             {/* <button className="svc-cta-primary">Start an AI Discovery Call</button> */}
//             <Link to="/contact">
//               <button className="svc-cta-primary">
//                 Start an AI Discovery Call
//               </button>
//             </Link>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }







// src/pages/AIIntegration.jsx
import React from "react";
import "./ServicePage.css";
import {
  FaRobot,
  FaComments,
  FaChartLine,
  FaBrain,
  FaCogs,
  FaBolt,
  FaPython,
  FaNodeJs,
  FaReact,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function AIIntegration() {
  return (
    <div className="svc-page">
      {/* HERO */}
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <div className="svc-hero-left">
            <span className="svc-hero-tag">AI Integration</span>
            <h1 className="svc-hero-title">
              Add <span className="svc-hero-highlight">AI superpowers</span> to
              your products and workflows.
            </h1>
            <p className="svc-hero-subtitle">
              We help you embed AI into your apps — from chatbots and automation
              to prediction and personalization — using practical,
              production-ready architectures.
            </p>

            <ul className="svc-hero-points">
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  AI chatbots that actually understand your business domain.
                </span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Workflow automation that reduces manual, repetitive tasks.
                </span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Predictive insights you can trust, with clear visibility.
                </span>
              </li>
            </ul>
          </div>

          {/* RIGHT VISUAL */}
          <div className="svc-hero-right">
            <div className="svc-hero-orbit">
              <div className="svc-hero-orbit-ring" />
              <div className="svc-hero-orbit-center">
                <FaRobot />
              </div>

              <div className="svc-hero-pill-icon svc-hero-pill-top">
                <span className="svc-pill-dot" />
                <span>Chatbots</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-right">
                <span className="svc-pill-dot" />
                <span>Automation</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-bottom">
                <span className="svc-pill-dot" />
                <span>Analytics</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES WE USE */}
      <section className="svc-section">
        <div className="svc-section-header">
          <h2>Technologies We Use</h2>
          <p>
            We integrate cutting-edge technologies to deliver AI solutions that
            drive impactful results for your business.
          </p>
        </div>

        <div className="svc-grid-3">
          <div className="svc-card">
            <div className="svc-card-icon">
              <FaPython />
            </div>
            <h3>Python</h3>
            <p>
              The most powerful language for AI and machine learning development.
              Used for building scalable AI models and data pipelines.
            </p>
          </div>

          <div className="svc-card">
            <div className="svc-card-icon">
              <FaNodeJs />
            </div>
            <h3>Node.js</h3>
            <p>
              Fast and scalable server-side development for building AI-driven APIs
              and services.
            </p>
          </div>

          <div className="svc-card">
            <div className="svc-card-icon">
              <FaReact />
            </div>
            <h3>React</h3>
            <p>
              Building interactive, AI-powered user interfaces and dashboards.
              Seamlessly integrate with AI models for real-time data processing.
            </p>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="svc-inner">
        {/* WHAT WE BUILD */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>What we build with AI</h2>
            <p>
              We don&apos;t chase buzzwords — we focus on AI use cases that
              improve customer experience and internal productivity.
            </p>
          </div>

          <div className="svc-grid-3">
            <div className="svc-card">
              <div className="svc-card-icon">
                <FaComments />
              </div>
              <h3>AI Chatbots & Assistants</h3>
              <p>
                Domain-trained bots that answer questions, collect data, and
                route conversations — integrated with your CRM and internal
                systems.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaBolt />
              </div>
              <h3>Process Automation</h3>
              <p>
                Use AI to summarize tickets, draft replies, validate forms, and
                trigger workflows across your tools.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaBrain />
              </div>
              <h3>Prediction & Personalization</h3>
              <p>
                From churn risk to next-best-offer and content recommendations,
                we integrate ML models where they move the needle.
              </p>
            </div>
          </div>
        </section>

        {/* DELIVERY APPROACH + STACK */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>How we deliver AI projects</h2>
            <p>
              We focus on fast pilots, measurable KPIs, and integrations that
              respect your security and compliance needs.
            </p>
          </div>

          <div className="svc-stats-row" style={{ marginBottom: "16px" }}>
            <div className="svc-stat-card">
              <div className="svc-stat-label">01 · Discovery Workshop</div>
              <div className="svc-stat-value">
                Identify 2–3 high-impact use cases, data sources, and success
                metrics.
              </div>
            </div>
            <div className="svc-stat-card">
              <div className="svc-stat-label">02 · Pilot & Integrate</div>
              <div className="svc-stat-value">
                Build a small, focused pilot integrated with your app or tools.
              </div>
            </div>
            <div className="svc-stat-card">
              <div className="svc-stat-label">03 · Expand & Govern</div>
              <div className="svc-stat-value">
                Scale to more teams and features with guardrails and monitoring.
              </div>
            </div>
          </div>

          <div className="svc-card">
            <h3>Platforms & tooling</h3>
            <p className="svc-text-soft">
              We combine modern AI platforms with your existing stack.
            </p>
            <div className="svc-chip-row" style={{ marginTop: "10px" }}>
              <span className="svc-chip">OpenAI / Azure OpenAI</span>
              <span className="svc-chip">Vector search & embeddings</span>
              <span className="svc-chip">Python / Node.js</span>
              <span className="svc-chip">React & React Native</span>
              <span className="svc-chip">LangChain / custom pipelines</span>
              <span className="svc-chip">Your existing APIs & DBs</span>
            </div>
          </div>

          <div className="svc-cta-block">
            <h3>Ready to run an AI pilot?</h3>
            <p>
              Tell us where you want to save time or improve experience. We’ll
              propose 1–2 AI experiments with timelines and estimated impact.
            </p>
            <Link to="/contact">
              <button className="svc-cta-primary">
                Start an AI Discovery Call
              </button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
